import { jsx as n } from "react/jsx-runtime";
import f from "react";
import w from "react-markdown";
import M from "rehype-raw";
import y from "remark-gfm";
import { ChatMarkdownProvider as g } from "../../providers/markdown-provider.js";
import { CodeBlock as C } from "../codeblock/index.js";
import { MarkdownCode as b, MarkdownTh as P, MarkdownTd as S, MarkdownTable as x, MarkdownSourceLink as L, MarkdownOl as R, MarkdownInput as T, MarkdownUl as $, MarkdownLi as j, MarkdownP as v, MarkdownH2 as A, MarkdownH1 as E, MarkdownLink as H } from "./components.js";
import { rehypeInlineCodeProperty as I } from "./rehype-inline-code-property.js";
const J = ({
  children: l,
  componentStyles: a,
  shouldOpenLinksInNewTab: h,
  onLinkClick: m,
  onCodeCopy: s,
  ...p
}) => {
  if (!l) return null;
  const k = {
    h1: ({ children: r }) => /* @__PURE__ */ n(E, { children: r }),
    h2: ({ children: r }) => /* @__PURE__ */ n(A, { children: r }),
    p: ({ children: r }) => /* @__PURE__ */ n(v, { children: r }),
    li: ({ children: r }) => /* @__PURE__ */ n(j, { children: r }),
    ul: ({ children: r }) => /* @__PURE__ */ n($, { children: r }),
    input: ({ type: r, checked: e, disabled: o, readOnly: t, required: i, value: d }) => /* @__PURE__ */ n(
      T,
      {
        type: r,
        checked: e,
        disabled: o,
        readOnly: t,
        required: i,
        value: d
      }
    ),
    ol: ({ children: r, node: e }) => {
      const o = e?.properties?.start, t = typeof o == "number" ? o : void 0;
      return /* @__PURE__ */ n(
        R,
        {
          style: {
            "--start": o?.toString() ?? "0"
          },
          start: t,
          children: r
        }
      );
    },
    a: ({ children: r, href: e }) => {
      const o = f.Children.toArray(r), t = o[0], i = typeof t == "string" && /^\(\d+\)$/.test(t) && o.length === 1, d = i ? t.match(/\d+/) : r, c = /* @__PURE__ */ n(
        H,
        {
          isExternal: h,
          href: e,
          onClick: () => {
            m?.(e, d?.toString());
          },
          children: d
        }
      );
      return i ? /* @__PURE__ */ n(L, { children: c }) : c;
    },
    img: ({ src: r, alt: e }) => `![${e || ""}](${r || ""})`,
    table: ({ children: r }) => /* @__PURE__ */ n(x, { children: r }),
    th: ({ children: r, isHeader: e }) => e ? /* @__PURE__ */ n(P, { children: r }) : /* @__PURE__ */ n(S, { children: r }),
    pre: ({ children: r }) => /* @__PURE__ */ n("pre", { children: r }),
    code: ({ children: r, inline: e, className: o }) => e ? /* @__PURE__ */ n(b, { children: r }) : /* @__PURE__ */ n(C, { className: o, onCopy: s, children: r })
  }, u = /* @__PURE__ */ n(
    w,
    {
      remarkPlugins: [y],
      rehypePlugins: [M, I],
      components: k,
      disallowedElements: _,
      children: l.toString(),
      ...p
    }
  );
  return /* @__PURE__ */ n(g, { componentStyles: a, children: u });
}, _ = [
  "script",
  "iframe",
  "frame",
  "embed",
  "meta",
  "base",
  "form",
  "style",
  "object"
];
export {
  J as Markdown
};
